import React, { Suspense, lazy } from 'react';

const TimeSeriesTable = lazy(() =>
  import(/* webpackChunkName: "TimeSeriesTable" */ '../../components/survey/time_series/TimeSeriesTable')
);

const LoadingComponent = () => (
  <div className="row">
    <div className="span3"></div>
    <div className="span6"><i className="fa-solid fa-spinner fa-spin-pulse light-blue fa-2xl text-center"></i></div>
    <div className="span3"></div>
  </div>
);

export default function TimeSeriesTableComponent({...props}) {
  return (
    <Suspense fallback={<LoadingComponent />}>
      <TimeSeriesTable {...props} />
    </Suspense>
  );
}
